/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archival_Error_SaveInputs */



/**
* | output |
* | --- |
* | "Could not save the archival results" |
*
* @param {Archival_Error_SaveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archival_error_save = /** @type {((inputs?: Archival_Error_SaveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archival_Error_SaveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'enregistrer les résultats d'archive")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se han podido guardar los resultados de archivo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível salvar os resultados de arquivo")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile salvare i risultati d'archivio")
	return /** @type {LocalizedString} */ ("Could not save the archival results")
});